import React from 'react';

/** Color icon output taken from Figma SVGs */

const cloudthreeDBoxColor = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Name=Cloud 3D Box, Style=Color">
      <g id="cloud">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.10547 11.8809L5.271 12.0889C3.96592 12.4144 3 13.5956 3 15C3 16.6569 4.34315 18 6 18H16.7062L16.9102 17.9816C19.2028 17.775 21 15.8468 21 13.5C21 11.3073 19.4307 9.47899 17.3537 9.08068L16.8154 8.97746L16.6128 8.4682C15.8039 6.43463 13.8183 5 11.5 5C8.46243 5 6 7.46243 6 10.5C6 10.6772 6.00835 10.8522 6.02463 11.0247L6.10547 11.8809ZM17 18.9776V19H6C3.79086 19 2 17.2091 2 15C2 13.1257 3.28911 11.5525 5.02906 11.1187C5.00983 10.915 5 10.7087 5 10.5C5 6.91015 7.91015 4 11.5 4C14.2416 4 16.5868 5.69737 17.542 8.09857C20.0813 8.58552 22 10.8187 22 13.5C22 16.369 19.8032 18.725 17 18.9776Z"
          fill="url(#paint0_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 9.77778L12 8L8 9.77778V14.2222L12 16L16 14.2222V9.77778ZM15.0767 9.91457L12 8.54716L8.92333 9.91457L12 11.1187L15.0767 9.91457ZM11.5 12L8.92333 11.0247V13.8973L11.5 15V12ZM12.5 12V15L15.0767 13.8973V11.0247L12.5 12Z"
          fill="url(#paint1_linear)"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="-4.39962"
        y1="11.5199"
        x2="7.68642"
        y2="28.0782"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="-4.39962"
        y1="11.5199"
        x2="7.68642"
        y2="28.0782"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
    </defs>
  </svg>
);

const pencilColor = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Name=Pencil, Style=Color">
      <g id="edit-pencil">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.4601 5.52562C17.9185 4.87566 16.9397 4.82036 16.3283 5.40517L6.47053 14.8343L6.08184 17.5551L8.28247 17.4176L18.3623 7.5021C18.9042 6.96906 18.9467 6.10954 18.4601 5.52562ZM15.637 4.68253C16.667 3.69736 18.3159 3.79051 19.2283 4.88544C20.0481 5.86911 19.9764 7.31704 19.0636 8.21499L8.85064 18.2614C8.7648 18.3459 8.65137 18.3965 8.53119 18.404L5.53119 18.5915C5.38108 18.6009 5.23472 18.5422 5.13268 18.4317C5.03064 18.3212 4.98376 18.1707 5.00503 18.0218L5.50503 14.5218C5.52086 14.4109 5.57346 14.3086 5.65439 14.2312L15.637 4.68253Z"
          fill="url(#paint0_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.1464 8.94602L14.6464 6.44602L15.3536 5.73892L17.8536 8.23892L17.1464 8.94602Z"
          fill="url(#paint1_linear)"
        />
        <path
          d="M4 20.5C4 20.2239 4.22386 20 4.5 20H19.5C19.7761 20 20 20.2239 20 20.5C20 20.7761 19.7761 21 19.5 21H4.5C4.22386 21 4 20.7761 4 20.5Z"
          fill="url(#paint2_linear)"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="-1.1197"
        y1="12.5225"
        x2="13.2543"
        y2="26.4233"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="-1.1197"
        y1="12.5225"
        x2="13.2543"
        y2="26.4233"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="-1.1197"
        y1="12.5225"
        x2="13.2543"
        y2="26.4233"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
    </defs>
  </svg>
);

const cartColor = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Name=cart, Style=Color">
      <g id="cart">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 21C8.55228 21 9 20.5523 9 20C9 19.4477 8.55228 19 8 19C7.44772 19 7 19.4477 7 20C7 20.5523 7.44772 21 8 21ZM8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22Z"
          fill="url(#paint0_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 21C16.5523 21 17 20.5523 17 20C17 19.4477 16.5523 19 16 19C15.4477 19 15 19.4477 15 20C15 20.5523 15.4477 21 16 21ZM16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22Z"
          fill="url(#paint1_linear)"
        />
        <path
          d="M18.1848 12.3013L17.585 14.5H5.41744L5.02855 8.5H10.0907C10.0311 8.17573 10 7.8415 10 7.5L4.94732 7.5C4.897 7.25838 4.79863 6.95927 4.60631 6.66437C4.18718 6.02171 3.39096 5.5 2 5.5V6.5C3.10904 6.5 3.56282 6.89496 3.76869 7.21064C3.99883 7.56351 4 7.94028 4 8V8.01388L4.44468 16.0182L4.44524 16.0396C4.44595 16.0603 4.44729 16.0883 4.4498 16.1225C4.45482 16.1909 4.4646 16.2852 4.48374 16.3969C4.52163 16.6181 4.59834 16.9204 4.75667 17.2285C4.91616 17.5389 5.16253 17.8624 5.53954 18.107C5.91901 18.3531 6.40138 18.5 7 18.5L18.5 18.5V17.5L7 17.5C6.57084 17.5 6.28238 17.3969 6.08373 17.268C5.88261 17.1376 5.74356 16.9611 5.6461 16.7715C5.59937 16.6805 5.56315 15.5883 5.53518 15.5H18.415L19.3696 11.4084C19.018 11.7566 18.6196 12.0576 18.1848 12.3013Z"
          fill="url(#paint2_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5 12C17.9853 12 20 9.98528 20 7.5C20 5.01472 17.9853 3 15.5 3C13.0147 3 11 5.01472 11 7.5C11 9.98528 13.0147 12 15.5 12ZM15.5 13C18.5376 13 21 10.5376 21 7.5C21 4.46243 18.5376 2 15.5 2C12.4624 2 10 4.46243 10 7.5C10 10.5376 12.4624 13 15.5 13Z"
          fill="url(#paint3_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.3536 5.64645C18.5488 5.84171 18.5488 6.15829 18.3536 6.35355L14.8536 9.85355C14.6583 10.0488 14.3417 10.0488 14.1464 9.85355L12.6464 8.35355C12.4512 8.15829 12.4512 7.84171 12.6464 7.64645C12.8417 7.45118 13.1583 7.45118 13.3536 7.64645L14.5 8.79289L17.6464 5.64645C17.8417 5.45118 18.1583 5.45118 18.3536 5.64645Z"
          fill="url(#paint4_linear)"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="-4.07964"
        y1="12.0265"
        x2="12.8354"
        y2="28.5382"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="-4.07964"
        y1="12.0265"
        x2="12.8354"
        y2="28.5382"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="-4.07964"
        y1="12.0265"
        x2="12.8354"
        y2="28.5382"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="-4.07964"
        y1="12.0265"
        x2="12.8354"
        y2="28.5382"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="-4.07964"
        y1="12.0265"
        x2="12.8354"
        y2="28.5382"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
    </defs>
  </svg>
);

const laptopthreeDBoxColor = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Name=laptop+3D Box, Style=Color">
      <path
        id="laptop"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 9.22222L12 7L7 9.22222V14.7778L12 17L17 14.7778V9.22222ZM15.1533 9.4958L12 8.09432L8.84666 9.4958L12 10.8973L15.1533 9.4958ZM11.5 11.7694L8 10.2138V14.1279L11.5 15.6835V11.7694ZM12.5 11.7694V15.6835L16 14.1279V10.2138L12.5 11.7694ZM2 18C2 18.5523 2.44772 19 3 19H21C21.5523 19 22 18.5523 22 18H2ZM19 6V17H20V6C20 5.44772 19.5523 5 19 5H5C4.44772 5 4 5.44772 4 6V17H5V6H19Z"
        fill="url(#paint0_linear)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="-4.39962"
        y1="12.0185"
        x2="6.62245"
        y2="28.1978"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
    </defs>
  </svg>
);

const quoteColor = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Name=quote, Style=Color">
      <path
        id="quotes"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 2.5C7 2.22386 7.22386 2 7.5 2H19C19.8284 2 20.5 2.67157 20.5 3.5V21C20.5 21.2761 20.2761 21.5 20 21.5C19.7239 21.5 19.5 21.2761 19.5 21V3.5C19.5 3.22386 19.2761 3 19 3H7.5C7.22386 3 7 2.77614 7 2.5ZM4 5.5C4 4.67157 4.67157 4 5.5 4H17C17.8284 4 18.5 4.67157 18.5 5.5V20.5C18.5 21.3284 17.8284 22 17 22H5.5C4.67157 22 4 21.3284 4 20.5V5.5ZM5.5 5C5.22386 5 5 5.22386 5 5.5V20.5C5 20.7761 5.22386 21 5.5 21H17C17.2761 21 17.5 20.7761 17.5 20.5V5.5C17.5 5.22386 17.2761 5 17 5H5.5ZM5.5 6.5C5.5 6.22386 5.72386 6 6 6H16C16.2761 6 16.5 6.22386 16.5 6.5C16.5 6.77614 16.2761 7 16 7H6C5.72386 7 5.5 6.77614 5.5 6.5ZM10.5 7.5C10.7761 7.5 11 7.72386 11 8V9.01813C12.0511 9.09764 12.7258 9.4328 13.175 9.90563C13.4243 10.168 13.5817 10.4502 13.6957 10.6957C13.7481 10.8086 13.7933 10.9184 13.8318 11.0117C13.8346 11.0186 13.8374 11.0254 13.8402 11.0321C13.8825 11.1347 13.915 11.2119 13.9472 11.2764C14.0707 11.5234 13.9706 11.8237 13.7236 11.9472C13.4766 12.0707 13.1763 11.9706 13.0528 11.7236C13.0017 11.6215 12.956 11.5111 12.9157 11.4133L12.9089 11.3968C12.869 11.3 12.8315 11.2091 12.7887 11.1168C12.6995 10.9248 12.5966 10.7487 12.45 10.5944C12.175 10.3049 11.6568 10 10.5 10C9.37247 10 8.73063 10.4099 8.43635 10.8448C8.13872 11.2847 8.14382 11.8143 8.41603 12.2226C8.51596 12.3726 8.75343 12.535 9.20116 12.7006C9.58556 12.8427 10.0422 12.9594 10.5472 13.0885C10.6116 13.105 10.6769 13.1217 10.7428 13.1386C11.3097 13.2843 11.9229 13.449 12.469 13.6791C13.0121 13.9079 13.5419 14.2225 13.9 14.7C14.5353 15.5471 14.5226 16.647 13.9879 17.5127C13.5145 18.2791 12.6508 18.8454 11.5 18.9729V20C11.5 20.2761 11.2761 20.5 11 20.5C10.7239 20.5 10.5 20.2761 10.5 20V18.979C8.65548 18.8209 7.5 17.7873 7.5 16.5C7.5 16.2239 7.72386 16 8 16C8.27614 16 8.5 16.2239 8.5 16.5C8.5 17.1 9.13333 18 11 18C12.0988 18 12.8017 17.5302 13.1371 16.9873C13.4774 16.4363 13.4647 15.7863 13.1 15.3C12.8956 15.0275 12.5534 14.7997 12.0807 14.6006C11.6111 14.4027 11.0647 14.2538 10.4939 14.1072C10.4294 14.0906 10.3645 14.074 10.2992 14.0573C9.80325 13.9308 9.29136 13.8001 8.85428 13.6385C8.37397 13.4608 7.87106 13.208 7.58397 12.7774C7.08214 12.0246 7.08725 11.0542 7.60812 10.2844C8.06639 9.6071 8.88453 9.13245 10 9.02372V8C10 7.72386 10.2239 7.5 10.5 7.5Z"
        fill="url(#paint0_linear)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="-1.27969"
        y1="12.0265"
        x2="15.412"
        y2="26.1762"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
    </defs>
  </svg>
);

const chatColor = (
  <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.00085 17.1231C1.01867 17.1002 1.05286 17.0623 1.1148 17.0096C1.29931 16.8529 1.62108 16.6646 2.09921 16.4738C3.00034 16.1143 4.2668 15.8202 5.67571 15.659C6.36954 15.8822 7.14282 16 8 16C8.85718 16 9.63046 15.8822 10.3243 15.659C11.7332 15.8202 12.9997 16.1143 13.9008 16.4738C14.3789 16.6646 14.7007 16.8529 14.8852 17.0096C14.9471 17.0623 14.9813 17.1002 14.9991 17.1231C14.987 17.5768 14.8365 18.1926 14.0774 18.7462C13.2163 19.3742 11.4685 20 8 20C4.53149 20 2.78368 19.3742 1.92259 18.7462C1.16347 18.1926 1.01303 17.5768 1.00085 17.1231ZM10.2113 14.6408C13.3199 14.9631 16 15.9238 16 17.0589C16 18.4582 15.1111 21 8 21C0.888889 21 0 18.4582 0 17.0589C0 15.9238 2.68015 14.9631 5.78868 14.6408C6.41796 14.8703 7.14967 15 8 15C8.85033 15 9.58204 14.8703 10.2113 14.6408Z"
      fill="url(#paint0_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.89191 4.22848C2.06479 5.83845 2.00431 7.95571 2.48507 9.87873L1.51492 10.1213C0.995681 8.04429 1.03143 5.66155 2.00243 3.77152C2.99451 1.84044 4.92553 0.5 8 0.5C11.0745 0.5 13.0055 1.84044 13.9976 3.77152C14.9686 5.66155 15.0043 8.04429 14.4851 10.1213L13.5149 9.87873C13.9957 7.95571 13.9352 5.83845 13.1081 4.22848C12.3021 2.65956 10.7331 1.5 8 1.5C5.26692 1.5 3.69794 2.65956 2.89191 4.22848Z"
      fill="url(#paint1_linear)"
    />
    <path
      d="M0.552336 8.99863C0.523431 8.4471 0.947101 7.97657 1.49863 7.94766C2.05016 7.91876 2.52069 8.34243 2.54959 8.89396L2.65427 10.8912C2.68317 11.4427 2.2595 11.9133 1.70797 11.9422C1.15645 11.9711 0.685912 11.5474 0.657008 10.9959L0.552336 8.99863Z"
      fill="url(#paint2_linear)"
    />
    <path
      d="M13.4477 8.99863C13.4766 8.4471 13.9471 8.02343 14.4986 8.05234C15.0502 8.08124 15.4738 8.55177 15.4449 9.1033L15.3403 11.1006C15.3113 11.6521 14.8408 12.0758 14.2893 12.0469C13.7378 12.018 13.3141 11.5474 13.343 10.9959L13.4477 8.99863Z"
      fill="url(#paint3_linear)"
    />
    <path
      d="M9 12C9.55229 12 10 12.4477 10 13C10 13.5523 9.55229 14 9 14H8C7.44772 14 7 13.5523 7 13C7 12.4477 7.44772 12 8 12H9Z"
      fill="url(#paint4_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.02206 12.4882C12.523 12.6428 13.4262 11.2663 13.5126 10.8885L14.4874 11.1115C14.2405 12.1914 12.677 13.6506 8.97794 13.4872L9.02206 12.4882Z"
      fill="url(#paint5_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2469 12.7045C11.8598 11.2686 12 9.45647 12 8.08696C12 5.85253 9.92533 4 8 4C6.07467 4 4 5.85253 4 8.08696C4 9.45647 4.14021 11.2686 4.75307 12.7045C5.05457 13.4109 5.45038 13.9779 5.95458 14.3669C6.44513 14.7454 7.0949 15 8 15C8.9051 15 9.55487 14.7454 10.0454 14.3669C10.5496 13.9779 10.9454 13.4109 11.2469 12.7045ZM8 16C12.4444 16 13 10.8964 13 8.08696C13 5.27751 10.4546 3 8 3C5.5454 3 3 5.27751 3 8.08696C3 10.8964 3.55556 16 8 16Z"
      fill="url(#paint6_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="-5.1197"
        y1="10.7771"
        x2="11.8094"
        y2="24.3538"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="-5.1197"
        y1="10.7771"
        x2="11.8094"
        y2="24.3538"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="-5.1197"
        y1="10.7771"
        x2="11.8094"
        y2="24.3538"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
      <linearGradient
        id="paint3_linear"
        x1="-5.1197"
        y1="10.7771"
        x2="11.8094"
        y2="24.3538"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
      <linearGradient
        id="paint4_linear"
        x1="-5.1197"
        y1="10.7771"
        x2="11.8094"
        y2="24.3538"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
      <linearGradient
        id="paint5_linear"
        x1="-5.1197"
        y1="10.7771"
        x2="11.8094"
        y2="24.3538"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
      <linearGradient
        id="paint6_linear"
        x1="-5.1197"
        y1="10.7771"
        x2="11.8094"
        y2="24.3538"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79EBE6" />
        <stop offset="1" stopColor="#1182B1" />
      </linearGradient>
    </defs>
  </svg>
);

const iconLookup: Record<string, JSX.Element> = {
  cartColor: cartColor,
  chatColor: chatColor,
  cloudthreeDBoxColor: cloudthreeDBoxColor,
  laptopthreeDBoxColor: laptopthreeDBoxColor,
  pencilColor: pencilColor,
  quoteColor: quoteColor,
};

export default iconLookup;
